var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"display-form-field pr-0",class:[("col-" + _vm.col), ("fs-" + _vm.fontSize), { '-border': _vm.border }, { 'font-weight-bold': _vm.bold }]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }